import React, { useCallback, useEffect, useState } from "react";
import StackedColumnChart from "../../CHARTS/StackedColumnChart";
import Loading from "../../Extra/Loading";
import StackedAreaChart from "../../CHARTS/StackedAreaChart";

const PunctualityDetentionCodeWise = () => {
  const [fyYear, setFyYear] = useState("");
  const [fyYearData, setFyYearData] = useState([]);
  const [showingFyYear, setShowingFyYearData] = useState([]);

  const [chartData, setChartData] = useState({
    categories: [],
    series: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  // Fetch Data
  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(false);
    const url = `${process.env.REACT_APP_URL_PREFIX}pplosttraincountdetcodewise/fin_yr_array?fin_yr_array=${fyYear}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.token}`,

          "Content-Type": "application/json",
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();

      // Check if the data structure exists
      if (data?.data?.length > 0) {
        processChartData(data?.data[0]);
        setFyYearData(data?.financial_years);
        setShowingFyYearData(data?.data[0].fy);
      } else {
        setChartData({ categories: [], series: [] });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [fyYear]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  // Process chart data
  const processChartData = (lostTrainData) => {
    const qArray = ["Q1", "Q2", "Q3", "Q4", "total"];

    if (lostTrainData && lostTrainData?.data) {
      const categories = lostTrainData.data.map((dataObj) => dataObj.DET_CODE);

      const series = [
        { name: "QUATRE_1", data: [] },
        { name: "QUATRE_2", data: [] },
        { name: "QUATRE_3", data: [] },
        { name: "QUATRE_4", data: [] },
        { name: "total", data: [] },
      ];

      lostTrainData.data.forEach((dataObj) => {
        const trainQData = dataObj.data;
        series[0].data.push(trainQData[qArray[0]]);
        series[1].data.push(trainQData[qArray[1]]);
        series[2].data.push(trainQData[qArray[2]]);
        series[3].data.push(trainQData[qArray[3]]);
        series[4].data.push(trainQData[qArray[4]]);
      });

      setChartData({
        categories,
        series,
      });
    }
  };

  const handleFyyear = (e) => {
    if (e.target.value === showingFyYear) {
      return;
    }
    if (e.target.value !== "") {
      setFyYear(e.target.value);
    }
  };
  return (
    <div>
      <div className=" ps-1 pe-1 d-flex justify-content-between bg-dark text-white d-flex align-items-center">
        <div>
          <h6 className="">Punctuality Detention Wise fy-{showingFyYear}</h6>
        </div>
        <div
          style={{ fontSize: "12px" }}
          className="d-flex justify-content-evenly"
        >
          <div className="me-1">total D-code {chartData.categories.length}</div>
          <select
            onChange={(e) => {
              handleFyyear(e);
            }}
            className=""
          >
            <option value={""}>select FY</option>
            {fyYearData &&
              fyYearData.map((fy, index) => {
                return (
                  <option value={fy} key={index}>
                    {fy}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
      {loading ? <Loading /> : null}
      {chartData.categories.length > 0 ? (
        <StackedColumnChart data={chartData} from={"detention"} />
      ) : (
        <div>No Data Found</div>
      )}
      {/* {chartData.categories.length > 0 ? (
        <StackedAreaChart data={chartData} from={"detention"} />
      ) : (
        <div>No Data Found</div>
      )} */}
    </div>
  );
};

export default PunctualityDetentionCodeWise;
